import { GetGridHeadersRequest, GridHeader, UpdateGridHeadersRequest } from "../domain";
import { Observable } from "rxjs";
import { BaseRequest } from "../../data/shared/base.request";
import { HttpResponse } from "@angular/common/http";

export abstract class GridHeadersRepository {
  abstract getGridHeaders(request: BaseRequest<GetGridHeadersRequest>): Observable<GridHeader[]>;

  abstract updateGridHeaders(request: BaseRequest<UpdateGridHeadersRequest[]> | BaseRequest<UpdateGridHeadersRequest>): Observable<boolean>;

  abstract getSampleNetworkFiles(): Observable<HttpResponse<Blob>>;
  abstract getSampleJLUploadFiles(): Observable<HttpResponse<Blob>>;
  abstract getSampleLocationFile(): Observable<HttpResponse<Blob>>;
}
